import {CalculationNotificationQuickPriceResult} from "../../model/Opportunity";
import {CalculationNotificationServiceName, ToastNotificationServiceName} from "../../../utils/names/serviceNames";
import {CalculationsNotificationService} from "../../../opportunities_service/service/CalculationsNotificationService";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";
import './LqbPricerResultDialog.scss';

export interface LqbPricerResults {
    selectOption: (product: CalculationNotificationQuickPriceResult) => void;
    closeDialog: () => void;
    query: { myOrder: string };
    lqbPricerResults: CalculationNotificationQuickPriceResult[];
}

export class LqbPricerResultDialog {

    private $mdDialog: angular.material.IDialogService;
    private calculationService: CalculationsNotificationService;
    private toastNotificationService: ToastNotificationService;
    private $scope: LqbPricerResults;

    public static instance = ($event: MouseEvent,
                              lqbPricerResults: CalculationNotificationQuickPriceResult[]): angular.material.IDialogOptions => ({
        template: require('./LqbPricerResultDialog.html'),
        controller: [
            '$scope',
            'lqbPricerResults',
            '$mdDialog',
            CalculationNotificationServiceName,
            ToastNotificationServiceName,
            LqbPricerResultDialog],
        targetEvent: $event,
        fullscreen: true,
        clickOutsideToClose: true,
        locals: {
            lqbPricerResults: lqbPricerResults
        }
    });


    constructor($scope: LqbPricerResults,
                lqbPricerResults: CalculationNotificationQuickPriceResult[],
                $mdDialog: angular.material.IDialogService,
                calculationService: CalculationsNotificationService,
                toastNotificationService: ToastNotificationService) {
        this.$mdDialog = $mdDialog;
        this.calculationService = calculationService;
        this.toastNotificationService = toastNotificationService;
        this.$scope = $scope;
        $scope.lqbPricerResults = lqbPricerResults;
        $scope.query = {myOrder: 'point'};
        $scope.closeDialog = this.closeDialog;
        $scope.selectOption = this.selectOption;
    }

    closeDialog = () => {
        this.$mdDialog.cancel();
    };

    selectOption = (product: CalculationNotificationQuickPriceResult) => {
        this.calculationService.updateSelectedProduct(product).then(resp => {
            if (resp.status === 200) {
                this.toastNotificationService.generateSuccessMessage("Successfully updated the selected product");
                this.$scope.lqbPricerResults.forEach(prod => prod.selected = false);
                product.selected = true;
            }
        }, err => {
            console.log(err);
        })
    };

}